export const inactiveLinkedTaskText = `
At least one of linked tasks does not have start/end dates.
The dependency will be inactive until dates are defined.
`;

export const unlinkIconSize = '20';
